<template>
  <li
    :title="formatTitle(data.title)"
    class="layout-menu-card"
    :class="{ 'menu-item-draggable': data.id }">
    <a>
      <div class="icon-box icon-box-new" :class="{'icon-box-remind': remindShow}"  @click="pushRoute(data.url)">
        <img :src="data.menuIcon || emptyIcon" alt="">
      </div>
      <p>{{data.title}}</p>
    </a>
  </li>
</template>

<script>
  import bus from 'public/utils/bus'
  import { systemIconColors } from '@/layout/layout/conf'
  import { QtReportOpenMenuByFavorite } from '@/layout/utils/report-qt.js'
  import EmptyIcon from '../images/empty-icon.png'
  export default {
    props: {
      data: Object,
      remindShow: Boolean
    },
    data() {
      return {
        emptyIcon: EmptyIcon
      }
    },
    computed: {
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      }
    },
    methods: {
      formatTitle (title) {
        return title && title.length > 7 ? title : ''
      },
      pushRoute (path) {
        // 从框架布局进入，添加入口标记
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || path)
        const currentRoute = this.visitedViews.find(t => t.tag === path)
        if (currentRoute) {
          this.$router.push(currentRoute.path)
          this.$bus.$emit('TAB_CLICK', currentRoute.path, currentRoute.tag)
          QtReportOpenMenuByFavorite(currentRoute.path)
        } else {
          this.$router.push(path)
          this.$bus.$emit('TAB_CLICK', path, path)
          QtReportOpenMenuByFavorite(path)
        }
      },
      getSvgStyle (subSystem, icon) {
        return {
          maskImage: `url(${icon})`,
          backgroundColor: systemIconColors[subSystem] || systemIconColors.HOME
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-card {
  width: 120px;
  margin: 0 2px 4px;
  padding: 10px 0;
  text-align: center;
  border-radius: 12px;
  &.menu-item-draggable {
    cursor: move;
  }
  // background-color: #f5f5fa;
  .icon-box {
    border-radius: 10px;
    background: #ffffff;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    &-remind {
      &::before {
        content: '';
        background: #FF5555;
        width: 6px;
        height: 6px;
        position: absolute;
        border-radius: 50%;
        right: -3px;
        top: -3px;
      }
    }
  }
  .icon-box-new {
    border-radius: 10px;
    background: #ffffff;
    img {
      width: 42px;
      height: 42px;
      border-radius: 10px;
      outline: none;
      display: block;
    }

    &:hover {
      background-color: #f5f7ff;
      scale: 1.1;
    }
  }
  .icon {
    font-size: 24px;
    color: var(--g-color-primary);
    width: 26px;
    height: 28px;
    display: inline-block;
  }
  .svg {
    width: 26px;
    height: 28px;
    display: inline-block;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
  }
  a {
    display: block;
  }
  p {
    margin-top: 6px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #1d1c23;
  }

}
</style>



// WEBPACK FOOTER //
// src/layout/components/common-module-list/menu-item.vue